import { StatusQuestionConfig } from '@gripp/shared-logic';
import { OptionList, RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const StatusPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const status = config as StatusQuestionConfig;
  const statuses = status.statuses ?? [];

  return (
    <>
      {statuses.length > 0 ? <OptionList options={statuses} glyph="radio" /> : null}
      {statuses.length === 0 || status.openEndedResponse ? (
        <RuledLines count={2} />
      ) : null}
    </>
  );
};
